import React, {useState} from "react";
import {useVehiclesData} from "../../../hooks/useVehiclesData";
import {getDataFresh, getVehiclesData} from "../../../state/selectors";
import LoadingSpinner from "../../Utils/Spinner";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import SearchBar from "../../Utils/SearchBar";
import {useSelector} from "react-redux";
import KeyFinderRow from "./KeyFinderRow";
import Nav from "../../Nav/Nav";

export default function KeyFinder(props){
    const [searchText, setSearchText] = useState("");
    const [currentSearch, setCurrentSearch] = useState("");
    let params = {keys: true, page_size:500};

    if (currentSearch) {
        params.search = currentSearch;
    }

    const handleSearch = () => {
        setCurrentSearch(searchText);
    };

    const clear = () => {
        setCurrentSearch("");
        setSearchText("");
    };

    let dataFresh = useSelector(getDataFresh);
    let complete = useVehiclesData(params, dataFresh);
    let data = useSelector(getVehiclesData);



    if(!complete){
        return (
            <div>
                <Nav/>
                <LoadingSpinner/>
            </div>
        )
    }

    return (
        <div>
            <Nav/>
            <Box>
               <Title>Key Finder</Title>
               <Columns isMultiline>
                   <Column>
                       <SearchBar
                          handleSearch={handleSearch}
                          setSearchText={setSearchText}
                          searchText={searchText}
                          clear={clear}
                       />
                   </Column>
               </Columns>
            </Box>
            <Box>
                <Columns isMultiline>
                    <Column>
                        <Table isFullwidth>
                            <thead>
                                <th>Registration</th>
                                <th>Key Number</th>
                            </thead>
                            <tbody>
                            {data.results.map(vehicle => (
                                <KeyFinderRow
                                    data={vehicle}
                                />
                            ))}
                            </tbody>
                        </Table>
                    </Column>
                </Columns>
            </Box>
        </div>
    );


}